
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9910"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9910"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// package.json
var $6dd0effbdfbbcc0f$var$version = "1.1.14";
// packages/core/src/maths.ts
function $6dd0effbdfbbcc0f$var$clamp(min, input, max) {
    return Math.max(min, Math.min(input, max));
}
function $6dd0effbdfbbcc0f$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
function $6dd0effbdfbbcc0f$var$damp(x, y, lambda, deltaTime) {
    return $6dd0effbdfbbcc0f$var$lerp(x, y, 1 - Math.exp(-lambda * deltaTime));
}
function $6dd0effbdfbbcc0f$var$modulo(n, d) {
    return (n % d + d) % d;
}
// packages/core/src/animate.ts
var $6dd0effbdfbbcc0f$var$Animate = class {
    isRunning = false;
    value = 0;
    from = 0;
    to = 0;
    currentTime = 0;
    // These are instanciated in the fromTo method
    lerp;
    duration;
    easing;
    onUpdate;
    /**
   * Advance the animation by the given delta time
   *
   * @param deltaTime - The time in seconds to advance the animation
   */ advance(deltaTime) {
        if (!this.isRunning) return;
        let completed = false;
        if (this.duration && this.easing) {
            this.currentTime += deltaTime;
            const linearProgress = $6dd0effbdfbbcc0f$var$clamp(0, this.currentTime / this.duration, 1);
            completed = linearProgress >= 1;
            const easedProgress = completed ? 1 : this.easing(linearProgress);
            this.value = this.from + (this.to - this.from) * easedProgress;
        } else if (this.lerp) {
            this.value = $6dd0effbdfbbcc0f$var$damp(this.value, this.to, this.lerp * 60, deltaTime);
            if (Math.round(this.value) === this.to) {
                this.value = this.to;
                completed = true;
            }
        } else {
            this.value = this.to;
            completed = true;
        }
        if (completed) this.stop();
        this.onUpdate?.(this.value, completed);
    }
    /** Stop the animation */ stop() {
        this.isRunning = false;
    }
    /**
   * Set up the animation from a starting value to an ending value
   * with optional parameters for lerping, duration, easing, and onUpdate callback
   *
   * @param from - The starting value
   * @param to - The ending value
   * @param options - Options for the animation
   */ fromTo(from, to, { lerp: lerp2, duration: duration, easing: easing, onStart: onStart, onUpdate: onUpdate }) {
        this.from = this.value = from;
        this.to = to;
        this.lerp = lerp2;
        this.duration = duration;
        this.easing = easing;
        this.currentTime = 0;
        this.isRunning = true;
        onStart?.();
        this.onUpdate = onUpdate;
    }
};
// packages/core/src/debounce.ts
function $6dd0effbdfbbcc0f$var$debounce(callback, delay) {
    let timer;
    return function(...args) {
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = void 0;
            callback.apply(context, args);
        }, delay);
    };
}
// packages/core/src/dimensions.ts
var $6dd0effbdfbbcc0f$var$Dimensions = class {
    constructor(wrapper, content, { autoResize: autoResize = true, debounce: debounceValue = 250 } = {}){
        this.wrapper = wrapper;
        this.content = content;
        if (autoResize) {
            this.debouncedResize = $6dd0effbdfbbcc0f$var$debounce(this.resize, debounceValue);
            if (this.wrapper instanceof Window) window.addEventListener("resize", this.debouncedResize, false);
            else {
                this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
                this.wrapperResizeObserver.observe(this.wrapper);
            }
            this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
            this.contentResizeObserver.observe(this.content);
        }
        this.resize();
    }
    width = 0;
    height = 0;
    scrollHeight = 0;
    scrollWidth = 0;
    // These are instanciated in the constructor as they need information from the options
    debouncedResize;
    wrapperResizeObserver;
    contentResizeObserver;
    destroy() {
        this.wrapperResizeObserver?.disconnect();
        this.contentResizeObserver?.disconnect();
        if (this.wrapper === window && this.debouncedResize) window.removeEventListener("resize", this.debouncedResize, false);
    }
    resize = ()=>{
        this.onWrapperResize();
        this.onContentResize();
    };
    onWrapperResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        } else {
            this.width = this.wrapper.clientWidth;
            this.height = this.wrapper.clientHeight;
        }
    };
    onContentResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.scrollHeight = this.content.scrollHeight;
            this.scrollWidth = this.content.scrollWidth;
        } else {
            this.scrollHeight = this.wrapper.scrollHeight;
            this.scrollWidth = this.wrapper.scrollWidth;
        }
    };
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
};
// packages/core/src/emitter.ts
var $6dd0effbdfbbcc0f$var$Emitter = class {
    events = {};
    /**
   * Emit an event with the given data
   * @param event Event name
   * @param args Data to pass to the event handlers
   */ emit(event, ...args) {
        let callbacks = this.events[event] || [];
        for(let i = 0, length = callbacks.length; i < length; i++)callbacks[i]?.(...args);
    }
    /**
   * Add a callback to the event
   * @param event Event name
   * @param cb Callback function
   * @returns Unsubscribe function
   */ on(event, cb) {
        this.events[event]?.push(cb) || (this.events[event] = [
            cb
        ]);
        return ()=>{
            this.events[event] = this.events[event]?.filter((i)=>cb !== i);
        };
    }
    /**
   * Remove a callback from the event
   * @param event Event name
   * @param callback Callback function
   */ off(event, callback) {
        this.events[event] = this.events[event]?.filter((i)=>callback !== i);
    }
    /**
   * Remove all event listeners and clean up
   */ destroy() {
        this.events = {};
    }
};
// packages/core/src/virtual-scroll.ts
var $6dd0effbdfbbcc0f$var$LINE_HEIGHT = 100 / 6;
var $6dd0effbdfbbcc0f$var$listenerOptions = {
    passive: false
};
var $6dd0effbdfbbcc0f$var$VirtualScroll = class {
    constructor(element, options = {
        wheelMultiplier: 1,
        touchMultiplier: 1
    }){
        this.element = element;
        this.options = options;
        window.addEventListener("resize", this.onWindowResize, false);
        this.onWindowResize();
        this.element.addEventListener("wheel", this.onWheel, $6dd0effbdfbbcc0f$var$listenerOptions);
        this.element.addEventListener("touchstart", this.onTouchStart, $6dd0effbdfbbcc0f$var$listenerOptions);
        this.element.addEventListener("touchmove", this.onTouchMove, $6dd0effbdfbbcc0f$var$listenerOptions);
        this.element.addEventListener("touchend", this.onTouchEnd, $6dd0effbdfbbcc0f$var$listenerOptions);
    }
    touchStart = {
        x: 0,
        y: 0
    };
    lastDelta = {
        x: 0,
        y: 0
    };
    window = {
        width: 0,
        height: 0
    };
    emitter = new $6dd0effbdfbbcc0f$var$Emitter();
    /**
   * Add an event listener for the given event and callback
   *
   * @param event Event name
   * @param callback Callback function
   */ on(event, callback) {
        return this.emitter.on(event, callback);
    }
    /** Remove all event listeners and clean up */ destroy() {
        this.emitter.destroy();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.element.removeEventListener("wheel", this.onWheel, $6dd0effbdfbbcc0f$var$listenerOptions);
        this.element.removeEventListener("touchstart", this.onTouchStart, $6dd0effbdfbbcc0f$var$listenerOptions);
        this.element.removeEventListener("touchmove", this.onTouchMove, $6dd0effbdfbbcc0f$var$listenerOptions);
        this.element.removeEventListener("touchend", this.onTouchEnd, $6dd0effbdfbbcc0f$var$listenerOptions);
    }
    /**
   * Event handler for 'touchstart' event
   *
   * @param event Touch event
   */ onTouchStart = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: 0,
            y: 0
        };
        this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event: event
        });
    };
    /** Event handler for 'touchmove' event */ onTouchMove = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
        const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: deltaX,
            y: deltaY
        };
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onTouchEnd = (event)=>{
        this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: event
        });
    };
    /** Event handler for 'wheel' event */ onWheel = (event)=>{
        let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
        const multiplierX = deltaMode === 1 ? $6dd0effbdfbbcc0f$var$LINE_HEIGHT : deltaMode === 2 ? this.window.width : 1;
        const multiplierY = deltaMode === 1 ? $6dd0effbdfbbcc0f$var$LINE_HEIGHT : deltaMode === 2 ? this.window.height : 1;
        deltaX *= multiplierX;
        deltaY *= multiplierY;
        deltaX *= this.options.wheelMultiplier;
        deltaY *= this.options.wheelMultiplier;
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onWindowResize = ()=>{
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
};
// packages/core/src/lenis.ts
var $6dd0effbdfbbcc0f$export$2e2bcd8739ae039 = class {
    _isScrolling = false;
    // true when scroll is animating
    _isStopped = false;
    // true if user should not be able to scroll - enable/disable programmatically
    _isLocked = false;
    // same as isStopped but enabled/disabled when scroll reaches target
    _preventNextNativeScrollEvent = false;
    _resetVelocityTimeout = null;
    /**
   * Whether or not the user is touching the screen
   */ isTouching;
    /**
   * The time in ms since the lenis instance was created
   */ time = 0;
    /**
   * User data that will be forwarded through the scroll event
   *
   * @example
   * lenis.scrollTo(100, {
   *   userData: {
   *     foo: 'bar'
   *   }
   * })
   */ userData = {};
    /**
   * The last velocity of the scroll
   */ lastVelocity = 0;
    /**
   * The current velocity of the scroll
   */ velocity = 0;
    /**
   * The direction of the scroll
   */ direction = 0;
    /**
   * The options passed to the lenis instance
   */ options;
    /**
   * The target scroll value
   */ targetScroll;
    /**
   * The animated scroll value
   */ animatedScroll;
    // These are instanciated here as they don't need information from the options
    animate = new $6dd0effbdfbbcc0f$var$Animate();
    emitter = new $6dd0effbdfbbcc0f$var$Emitter();
    // These are instanciated in the constructor as they need information from the options
    dimensions;
    // This is not private because it's used in the Snap class
    virtualScroll;
    constructor({ wrapper: wrapper = window, content: content = document.documentElement, eventsTarget: eventsTarget = wrapper, smoothWheel: smoothWheel = true, syncTouch: syncTouch = false, syncTouchLerp: syncTouchLerp = 0.075, touchInertiaMultiplier: touchInertiaMultiplier = 35, duration: duration, easing: // in seconds
    easing = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t)), lerp: lerp2 = 0.1, infinite: infinite = false, orientation: orientation = "vertical", gestureOrientation: // vertical, horizontal
    gestureOrientation = "vertical", touchMultiplier: // vertical, horizontal, both
    touchMultiplier = 1, wheelMultiplier: wheelMultiplier = 1, autoResize: autoResize = true, prevent: prevent, virtualScroll: virtualScroll, overscroll: overscroll = true, __experimental__naiveDimensions: __experimental__naiveDimensions = false } = {}){
        window.lenisVersion = $6dd0effbdfbbcc0f$var$version;
        if (!wrapper || wrapper === document.documentElement || wrapper === document.body) wrapper = window;
        this.options = {
            wrapper: wrapper,
            content: content,
            eventsTarget: eventsTarget,
            smoothWheel: smoothWheel,
            syncTouch: syncTouch,
            syncTouchLerp: syncTouchLerp,
            touchInertiaMultiplier: touchInertiaMultiplier,
            duration: duration,
            easing: easing,
            lerp: lerp2,
            infinite: infinite,
            gestureOrientation: gestureOrientation,
            orientation: orientation,
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier,
            autoResize: autoResize,
            prevent: prevent,
            virtualScroll: virtualScroll,
            overscroll: overscroll,
            __experimental__naiveDimensions: __experimental__naiveDimensions
        };
        this.dimensions = new $6dd0effbdfbbcc0f$var$Dimensions(wrapper, content, {
            autoResize: autoResize
        });
        this.updateClassName();
        this.targetScroll = this.animatedScroll = this.actualScroll;
        this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, false);
        this.virtualScroll = new $6dd0effbdfbbcc0f$var$VirtualScroll(eventsTarget, {
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier
        });
        this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
    /**
   * Destroy the lenis instance, remove all event listeners and clean up the class name
   */ destroy() {
        this.emitter.destroy();
        this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, false);
        this.virtualScroll.destroy();
        this.dimensions.destroy();
        this.cleanUpClassName();
    }
    on(event, callback) {
        return this.emitter.on(event, callback);
    }
    off(event, callback) {
        return this.emitter.off(event, callback);
    }
    setScroll(scroll) {
        if (this.isHorizontal) this.rootElement.scrollLeft = scroll;
        else this.rootElement.scrollTop = scroll;
    }
    onPointerDown = (event)=>{
        if (event.button === 1) this.reset();
    };
    onVirtualScroll = (data)=>{
        if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false) return;
        const { deltaX: deltaX, deltaY: deltaY, event: event } = data;
        this.emitter.emit("virtual-scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
        if (event.ctrlKey) return;
        if (event.lenisStopPropagation) return;
        const isTouch = event.type.includes("touch");
        const isWheel = event.type.includes("wheel");
        this.isTouching = event.type === "touchstart" || event.type === "touchmove";
        const isTapToStop = this.options.syncTouch && isTouch && event.type === "touchstart" && !this.isStopped && !this.isLocked;
        if (isTapToStop) {
            this.reset();
            return;
        }
        const isClick = deltaX === 0 && deltaY === 0;
        const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
        if (isClick || isUnknownGesture) return;
        let composedPath = event.composedPath();
        composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
        const prevent = this.options.prevent;
        if (!!composedPath.find((node)=>node instanceof HTMLElement && (typeof prevent === "function" && prevent?.(node) || node.hasAttribute?.("data-lenis-prevent") || isTouch && node.hasAttribute?.("data-lenis-prevent-touch") || isWheel && node.hasAttribute?.("data-lenis-prevent-wheel")))) return;
        if (this.isStopped || this.isLocked) {
            event.preventDefault();
            return;
        }
        const isSmooth = this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel;
        if (!isSmooth) {
            this.isScrolling = "native";
            this.animate.stop();
            event.lenisStopPropagation = true;
            return;
        }
        let delta = deltaY;
        if (this.options.gestureOrientation === "both") delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
        else if (this.options.gestureOrientation === "horizontal") delta = deltaX;
        if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) event.lenisStopPropagation = true;
        event.preventDefault();
        const syncTouch = isTouch && this.options.syncTouch;
        const isTouchEnd = isTouch && event.type === "touchend";
        const hasTouchInertia = isTouchEnd && Math.abs(delta) > 5;
        if (hasTouchInertia) delta = this.velocity * this.options.touchInertiaMultiplier;
        this.scrollTo(this.targetScroll + delta, {
            programmatic: false,
            ...syncTouch ? {
                lerp: hasTouchInertia ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }
        });
    };
    /**
   * Force lenis to recalculate the dimensions
   */ resize() {
        this.dimensions.resize();
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.emit();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    onNativeScroll = ()=>{
        if (this._resetVelocityTimeout !== null) {
            clearTimeout(this._resetVelocityTimeout);
            this._resetVelocityTimeout = null;
        }
        if (this._preventNextNativeScrollEvent) {
            this._preventNextNativeScrollEvent = false;
            return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
            const lastScroll = this.animatedScroll;
            this.animatedScroll = this.targetScroll = this.actualScroll;
            this.lastVelocity = this.velocity;
            this.velocity = this.animatedScroll - lastScroll;
            this.direction = Math.sign(this.animatedScroll - lastScroll);
            this.isScrolling = "native";
            this.emit();
            if (this.velocity !== 0) this._resetVelocityTimeout = setTimeout(()=>{
                this.lastVelocity = this.velocity;
                this.velocity = 0;
                this.isScrolling = false;
                this.emit();
            }, 400);
        }
    };
    reset() {
        this.isLocked = false;
        this.isScrolling = false;
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.lastVelocity = this.velocity = 0;
        this.animate.stop();
    }
    /**
   * Start lenis scroll after it has been stopped
   */ start() {
        if (!this.isStopped) return;
        this.isStopped = false;
        this.reset();
    }
    /**
   * Stop lenis scroll
   */ stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        this.animate.stop();
        this.reset();
    }
    /**
   * RequestAnimationFrame for lenis
   *
   * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
   */ raf(time) {
        const deltaTime = time - (this.time || time);
        this.time = time;
        this.animate.advance(deltaTime * 1e-3);
    }
    /**
   * Scroll to a target value
   *
   * @param target The target value to scroll to
   * @param options The options for the scroll
   *
   * @example
   * lenis.scrollTo(100, {
   *   offset: 100,
   *   duration: 1,
   *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
   *   lerp: 0.1,
   *   onStart: () => {
   *     console.log('onStart')
   *   },
   *   onComplete: () => {
   *     console.log('onComplete')
   *   },
   * })
   */ scrollTo(target, { offset: offset = 0, immediate: immediate = false, lock: lock = false, duration: duration = this.options.duration, easing: easing = this.options.easing, lerp: lerp2 = this.options.lerp, onStart: onStart, onComplete: onComplete, force: force = false, programmatic: // scroll even if stopped
    programmatic = true, userData: // called from outside of the class
    userData } = {}) {
        if ((this.isStopped || this.isLocked) && !force) return;
        if (typeof target === "string" && [
            "top",
            "left",
            "start"
        ].includes(target)) target = 0;
        else if (typeof target === "string" && [
            "bottom",
            "right",
            "end"
        ].includes(target)) target = this.limit;
        else {
            let node;
            if (typeof target === "string") node = document.querySelector(target);
            else if (target instanceof HTMLElement && target?.nodeType) node = target;
            if (node) {
                if (this.options.wrapper !== window) {
                    const wrapperRect = this.rootElement.getBoundingClientRect();
                    offset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
                }
                const rect = node.getBoundingClientRect();
                target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll;
            }
        }
        if (typeof target !== "number") return;
        target += offset;
        target = Math.round(target);
        if (this.options.infinite) {
            if (programmatic) this.targetScroll = this.animatedScroll = this.scroll;
        } else target = $6dd0effbdfbbcc0f$var$clamp(0, target, this.limit);
        if (target === this.targetScroll) {
            onStart?.(this);
            onComplete?.(this);
            return;
        }
        this.userData = userData ?? {};
        if (immediate) {
            this.animatedScroll = this.targetScroll = target;
            this.setScroll(this.scroll);
            this.reset();
            this.preventNextNativeScrollEvent();
            this.emit();
            onComplete?.(this);
            this.userData = {};
            return;
        }
        if (!programmatic) this.targetScroll = target;
        this.animate.fromTo(this.animatedScroll, target, {
            duration: duration,
            easing: easing,
            lerp: lerp2,
            onStart: ()=>{
                if (lock) this.isLocked = true;
                this.isScrolling = "smooth";
                onStart?.(this);
            },
            onUpdate: (value, completed)=>{
                this.isScrolling = "smooth";
                this.lastVelocity = this.velocity;
                this.velocity = value - this.animatedScroll;
                this.direction = Math.sign(this.velocity);
                this.animatedScroll = value;
                this.setScroll(this.scroll);
                if (programmatic) this.targetScroll = value;
                if (!completed) this.emit();
                if (completed) {
                    this.reset();
                    this.emit();
                    onComplete?.(this);
                    this.userData = {};
                    this.preventNextNativeScrollEvent();
                }
            }
        });
    }
    preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = true;
        requestAnimationFrame(()=>{
            this._preventNextNativeScrollEvent = false;
        });
    }
    /**
   * The root element on which lenis is instanced
   */ get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    /**
   * The limit which is the maximum scroll value
   */ get limit() {
        if (this.options.__experimental__naiveDimensions) {
            if (this.isHorizontal) return this.rootElement.scrollWidth - this.rootElement.clientWidth;
            else return this.rootElement.scrollHeight - this.rootElement.clientHeight;
        } else return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    /**
   * Whether or not the scroll is horizontal
   */ get isHorizontal() {
        return this.options.orientation === "horizontal";
    }
    /**
   * The actual scroll value
   */ get actualScroll() {
        return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    /**
   * The current scroll value
   */ get scroll() {
        return this.options.infinite ? $6dd0effbdfbbcc0f$var$modulo(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    /**
   * The progress of the scroll relative to the limit
   */ get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    /**
   * Current scroll state
   */ get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(value) {
        if (this._isScrolling !== value) {
            this._isScrolling = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is stopped
   */ get isStopped() {
        return this._isStopped;
    }
    set isStopped(value) {
        if (this._isStopped !== value) {
            this._isStopped = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is locked
   */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        if (this._isLocked !== value) {
            this._isLocked = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is smooth scrolling
   */ get isSmooth() {
        return this.isScrolling === "smooth";
    }
    /**
   * The class name applied to the wrapper element
   */ get className() {
        let className = "lenis";
        if (this.isStopped) className += " lenis-stopped";
        if (this.isLocked) className += " lenis-locked";
        if (this.isScrolling) className += " lenis-scrolling";
        if (this.isScrolling === "smooth") className += " lenis-smooth";
        return className;
    }
    updateClassName() {
        this.cleanUpClassName();
        this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
};



var $9G9Pp = parcelRequire("9G9Pp");
/**
 * SplitType
 * https://github.com/lukePeavey/SplitType
 * @version 0.3.4
 * @author Luke Peavey <lwpeavey@gmail.com>
 */ // Polyfill the following DOM methods that are not supported in IE 11.
(function() {
    function append() {
        var length = arguments.length;
        for(var i = 0; i < length; i++){
            var node = i < 0 || arguments.length <= i ? undefined : arguments[i];
            if (node.nodeType === 1 || node.nodeType === 11) this.appendChild(node);
            else this.appendChild(document.createTextNode(String(node)));
        }
    }
    function replaceChildren() {
        while(this.lastChild)this.removeChild(this.lastChild);
        if (arguments.length) this.append.apply(this, arguments);
    }
    function replaceWith() {
        var parent = this.parentNode;
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        var i = nodes.length;
        if (!parent) return;
        if (!i) parent.removeChild(this);
        while(i--){
            var node = nodes[i];
            if (typeof node !== "object") node = this.ownerDocument.createTextNode(node);
            else if (node.parentNode) node.parentNode.removeChild(node);
            if (!i) parent.replaceChild(node, this);
            else parent.insertBefore(this.previousSibling, node);
        }
    }
    if (typeof Element !== "undefined") {
        if (!Element.prototype.append) {
            Element.prototype.append = append;
            DocumentFragment.prototype.append = append;
        }
        if (!Element.prototype.replaceChildren) {
            Element.prototype.replaceChildren = replaceChildren;
            DocumentFragment.prototype.replaceChildren = replaceChildren;
        }
        if (!Element.prototype.replaceWith) {
            Element.prototype.replaceWith = replaceWith;
            DocumentFragment.prototype.replaceWith = replaceWith;
        }
    }
})();
function $7b1e4f3aeef3b1b6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7b1e4f3aeef3b1b6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7b1e4f3aeef3b1b6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7b1e4f3aeef3b1b6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7b1e4f3aeef3b1b6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7b1e4f3aeef3b1b6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7b1e4f3aeef3b1b6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7b1e4f3aeef3b1b6$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7b1e4f3aeef3b1b6$var$ownKeys(Object(source), true).forEach(function(key) {
            $7b1e4f3aeef3b1b6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7b1e4f3aeef3b1b6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7b1e4f3aeef3b1b6$var$_slicedToArray(arr, i) {
    return $7b1e4f3aeef3b1b6$var$_arrayWithHoles(arr) || $7b1e4f3aeef3b1b6$var$_iterableToArrayLimit(arr, i) || $7b1e4f3aeef3b1b6$var$_unsupportedIterableToArray(arr, i) || $7b1e4f3aeef3b1b6$var$_nonIterableRest();
}
function $7b1e4f3aeef3b1b6$var$_toConsumableArray(arr) {
    return $7b1e4f3aeef3b1b6$var$_arrayWithoutHoles(arr) || $7b1e4f3aeef3b1b6$var$_iterableToArray(arr) || $7b1e4f3aeef3b1b6$var$_unsupportedIterableToArray(arr) || $7b1e4f3aeef3b1b6$var$_nonIterableSpread();
}
function $7b1e4f3aeef3b1b6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7b1e4f3aeef3b1b6$var$_arrayLikeToArray(arr);
}
function $7b1e4f3aeef3b1b6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7b1e4f3aeef3b1b6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $7b1e4f3aeef3b1b6$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7b1e4f3aeef3b1b6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b1e4f3aeef3b1b6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b1e4f3aeef3b1b6$var$_arrayLikeToArray(o, minLen);
}
function $7b1e4f3aeef3b1b6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7b1e4f3aeef3b1b6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7b1e4f3aeef3b1b6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Shallow merges the properties of an object with the target object. Only
 * includes properties that exist on the target object. Non-writable properties
 * on the target object will not be over-written.
 *
 * @param {Object} target
 * @param {Object} object
 */ function $7b1e4f3aeef3b1b6$var$extend(target, object) {
    return Object.getOwnPropertyNames(Object(target)).reduce(function(extended, key) {
        var currentValue = Object.getOwnPropertyDescriptor(Object(target), key);
        var newValue = Object.getOwnPropertyDescriptor(Object(object), key);
        return Object.defineProperty(extended, key, newValue || currentValue);
    }, {});
}
/**
 * Checks if given value is a string
 *
 * @param {any} value
 * @return {boolean} `true` if `value` is a string, else `false`
 */ function $7b1e4f3aeef3b1b6$var$isString(value) {
    return typeof value === "string";
}
function $7b1e4f3aeef3b1b6$var$isArray(value) {
    return Array.isArray(value);
}
/**
 * Parses user supplied settings objects.
 */ function $7b1e4f3aeef3b1b6$var$parseSettings() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var object = $7b1e4f3aeef3b1b6$var$extend(settings); // `split` may be used as an alias for the `types` option
    // Parse the `types` settings into an array of valid split types.
    // If `types` is explicitly set to an empty string or array, text will not be
    // split at all.
    var types;
    if (object.types !== undefined) types = object.types;
    else if (object.split !== undefined) types = object.split;
    if (types !== undefined) object.types = ($7b1e4f3aeef3b1b6$var$isString(types) || $7b1e4f3aeef3b1b6$var$isArray(types) ? String(types) : "").split(",").map(function(type) {
        return String(type).trim();
    }).filter(function(type) {
        return /((line)|(word)|(char))/i.test(type);
    });
     // Support `position: absolute` as an alias for `absolute: true`
    if (object.absolute || object.position) object.absolute = object.absolute || /absolute/.test(settings.position);
    return object;
}
/**
 * Takes a list of `types` and returns an object
 *
 * @param {string | string[]} value a comma separated list of split types
 * @return {{lines: boolean, words: boolean, chars: boolean}}
 */ function $7b1e4f3aeef3b1b6$var$parseTypes(value) {
    var types = $7b1e4f3aeef3b1b6$var$isString(value) || $7b1e4f3aeef3b1b6$var$isArray(value) ? String(value) : "";
    return {
        none: !types,
        lines: /line/i.test(types),
        words: /word/i.test(types),
        chars: /char/i.test(types)
    };
}
/**
 * Returns true if `value` is a non-null object.
 * @param {any} value
 * @return {boolean}
 */ function $7b1e4f3aeef3b1b6$var$isObject(value) {
    return value !== null && typeof value === "object";
}
/**
 * Returns true if `input` is one of the following:
 * - `Element`
 * - `Text`
 * - `DocumentFragment`
 */ function $7b1e4f3aeef3b1b6$var$isNode(input) {
    return $7b1e4f3aeef3b1b6$var$isObject(input) && /^(1|3|11)$/.test(input.nodeType);
}
/**
 * Checks if `value` is a valid array-like length.
 * Original source: Lodash
 *
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3)
 * // => true
 *
 * _.isLength(Number.MIN_VALUE)
 * // => false
 *
 * _.isLength(Infinity)
 * // => false
 *
 * _.isLength('3')
 * // => false
 */ function $7b1e4f3aeef3b1b6$var$isLength(value) {
    return typeof value === "number" && value > -1 && value % 1 === 0;
}
/**
 * Checks if `value` is an array-like object
 * @param {any} value
 * @return {boolean} true if `value` is array-like`, else `false`
 * @example
 * isArrayLike(new Array())
 * // => true
 *
 * isArrayLike(document.querySelectorAll('div'))
 * // => true
 *
 * isArrayLike(document.getElementsByTagName('div'))
 * // => true
 *
 * isArrayLike(() => {})
 * // => false
 *
 * isArrayLike({foo: 'bar'})
 * // => false
 *
 * * isArrayLike(null)
 * // => false
 */ function $7b1e4f3aeef3b1b6$var$isArrayLike(value) {
    return $7b1e4f3aeef3b1b6$var$isObject(value) && $7b1e4f3aeef3b1b6$var$isLength(value.length);
}
/**
 * Coerces `value` to an `Array`.
 *
 * @param {any} value
 * @return {any[]}
 * @example
 * // If `value` is any `Array`, returns original `Array`
 * let arr = [1, 2]
 * toArray(arr)
 * // => arr
 *
 * // If `value` is an `ArrayLike`, its equivalent to `Array.from(value)`
 * let nodeList = document.querySelectorAll('div')
 * toArray(nodeList)
 * // => HTMLElement[] s
 *
 * // If value is falsy, returns empty array
 * toArray(null)
 * // => []
 *
 * // For any other type of value, its equivalent to `Array.of(value)`
 * let element = document.createElement('div')
 * toArray(element)
 * // => [element]
 *
 */ function $7b1e4f3aeef3b1b6$var$toArray(value) {
    if ($7b1e4f3aeef3b1b6$var$isArray(value)) return value;
    if (value == null) return [];
    return $7b1e4f3aeef3b1b6$var$isArrayLike(value) ? Array.prototype.slice.call(value) : [
        value
    ];
}
/**
 * Processes target elements for the splitType function.
 *
 * @param {any} target Can be one of the following:
 * 1. `string` - A css selector
 * 2. `HTMLElement` - A single element
 * 3. `NodeList` - A nodeList
 * 4. `Element[]` - An array of elements
 * 5. `Array<NodeList|Element[]>` - An nested array of elements
 * @returns {Element[]} A flat array HTML elements
 * @return A flat array of elements or empty array if no elements are found
 */ function $7b1e4f3aeef3b1b6$var$getTargetElements(target) {
    var elements = target; // If `target` is a selector string...
    if ($7b1e4f3aeef3b1b6$var$isString(target)) {
        if (/^(#[a-z]\w+)$/.test(target.trim())) // If `target` is an ID, use `getElementById`
        elements = document.getElementById(target.trim().slice(1));
        else // Else use `querySelectorAll`
        elements = document.querySelectorAll(target);
    } // Return a flattened array of elements
    return $7b1e4f3aeef3b1b6$var$toArray(elements).reduce(function(result, element) {
        return [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(result), $7b1e4f3aeef3b1b6$var$_toConsumableArray($7b1e4f3aeef3b1b6$var$toArray(element).filter($7b1e4f3aeef3b1b6$var$isNode)));
    }, []);
}
var $7b1e4f3aeef3b1b6$var$entries = Object.entries;
var $7b1e4f3aeef3b1b6$var$expando = "_splittype";
var $7b1e4f3aeef3b1b6$var$cache = {};
var $7b1e4f3aeef3b1b6$var$uid = 0;
/**
 * Stores data associated with DOM elements or other objects. This is a
 * simplified version of jQuery's data method.
 *
 * @signature Data(owner)
 * @description Get the data store object for the given owner.
 * @param {Object} owner the object that data will be associated with.
 * @return {Object} the data object for given `owner`. If no data exists
 *     for the given object, creates a new data store and returns it.
 *
 * @signature Data(owner, key)
 * @description Get the value
 * @param {Object} owner
 * @param {string} key
 * @return {any} the value of the provided key. If key does not exist, returns
 *     undefined.
 *
 * @signature Data(owner, key, value)
 * @description Sets the given key/value pair in data store
 * @param {Object} owner
 * @param {string} key
 * @param {any} value
 */ function $7b1e4f3aeef3b1b6$var$set(owner, key, value) {
    if (!$7b1e4f3aeef3b1b6$var$isObject(owner)) {
        console.warn("[data.set] owner is not an object");
        return null;
    }
    var id = owner[$7b1e4f3aeef3b1b6$var$expando] || (owner[$7b1e4f3aeef3b1b6$var$expando] = ++$7b1e4f3aeef3b1b6$var$uid);
    var data = $7b1e4f3aeef3b1b6$var$cache[id] || ($7b1e4f3aeef3b1b6$var$cache[id] = {});
    if (value === undefined) {
        if (!!key && Object.getPrototypeOf(key) === Object.prototype) $7b1e4f3aeef3b1b6$var$cache[id] = $7b1e4f3aeef3b1b6$var$_objectSpread2($7b1e4f3aeef3b1b6$var$_objectSpread2({}, data), key);
    } else if (key !== undefined) data[key] = value;
    return value;
}
function $7b1e4f3aeef3b1b6$var$get(owner, key) {
    var id = $7b1e4f3aeef3b1b6$var$isObject(owner) ? owner[$7b1e4f3aeef3b1b6$var$expando] : null;
    var data = id && $7b1e4f3aeef3b1b6$var$cache[id] || {};
    if (key === undefined) return data;
    return data[key];
}
/**
 * Remove all data associated with the given element
 */ function $7b1e4f3aeef3b1b6$var$remove(element) {
    var id = element && element[$7b1e4f3aeef3b1b6$var$expando];
    if (id) {
        delete element[id];
        delete $7b1e4f3aeef3b1b6$var$cache[id];
    }
}
/**
 * Clear all cached data
 */ function $7b1e4f3aeef3b1b6$var$clear() {
    Object.keys($7b1e4f3aeef3b1b6$var$cache).forEach(function(key) {
        delete $7b1e4f3aeef3b1b6$var$cache[key];
    });
}
/**
 * Remove all temporary data from the store.
 */ function $7b1e4f3aeef3b1b6$var$cleanup() {
    $7b1e4f3aeef3b1b6$var$entries($7b1e4f3aeef3b1b6$var$cache).forEach(function(_ref) {
        var _ref2 = $7b1e4f3aeef3b1b6$var$_slicedToArray(_ref, 2), id = _ref2[0], _ref2$ = _ref2[1], isRoot = _ref2$.isRoot, isSplit = _ref2$.isSplit;
        if (!isRoot || !isSplit) {
            $7b1e4f3aeef3b1b6$var$cache[id] = null;
            delete $7b1e4f3aeef3b1b6$var$cache[id];
        }
    });
}
/**
 * Splits a string into an array of words.
 *
 * @param {string} string
 * @param {string | RegExp} [separator = ' ']
 * @return {string[]} Array of words
 */ function $7b1e4f3aeef3b1b6$var$toWords(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
    var string = value ? String(value) : "";
    return string.trim().replace(/\s+/g, " ").split(separator);
}
/**
 * Based on lodash#split <https://lodash.com/license>
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &
 * Editors
 */ var $7b1e4f3aeef3b1b6$var$rsAstralRange = "\ud800-\udfff";
var $7b1e4f3aeef3b1b6$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23";
var $7b1e4f3aeef3b1b6$var$rsComboSymbolsRange = "\\u20d0-\\u20f0";
var $7b1e4f3aeef3b1b6$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $7b1e4f3aeef3b1b6$var$rsAstral = "[".concat($7b1e4f3aeef3b1b6$var$rsAstralRange, "]");
var $7b1e4f3aeef3b1b6$var$rsCombo = "[".concat($7b1e4f3aeef3b1b6$var$rsComboMarksRange).concat($7b1e4f3aeef3b1b6$var$rsComboSymbolsRange, "]");
var $7b1e4f3aeef3b1b6$var$rsFitz = "\ud83c[\udffb-\udfff]";
var $7b1e4f3aeef3b1b6$var$rsModifier = "(?:".concat($7b1e4f3aeef3b1b6$var$rsCombo, "|").concat($7b1e4f3aeef3b1b6$var$rsFitz, ")");
var $7b1e4f3aeef3b1b6$var$rsNonAstral = "[^".concat($7b1e4f3aeef3b1b6$var$rsAstralRange, "]");
var $7b1e4f3aeef3b1b6$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}";
var $7b1e4f3aeef3b1b6$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]";
var $7b1e4f3aeef3b1b6$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $7b1e4f3aeef3b1b6$var$reOptMod = "".concat($7b1e4f3aeef3b1b6$var$rsModifier, "?");
var $7b1e4f3aeef3b1b6$var$rsOptVar = "[".concat($7b1e4f3aeef3b1b6$var$rsVarRange, "]?");
var $7b1e4f3aeef3b1b6$var$rsOptJoin = "(?:" + $7b1e4f3aeef3b1b6$var$rsZWJ + "(?:" + [
    $7b1e4f3aeef3b1b6$var$rsNonAstral,
    $7b1e4f3aeef3b1b6$var$rsRegional,
    $7b1e4f3aeef3b1b6$var$rsSurrPair
].join("|") + ")" + $7b1e4f3aeef3b1b6$var$rsOptVar + $7b1e4f3aeef3b1b6$var$reOptMod + ")*";
var $7b1e4f3aeef3b1b6$var$rsSeq = $7b1e4f3aeef3b1b6$var$rsOptVar + $7b1e4f3aeef3b1b6$var$reOptMod + $7b1e4f3aeef3b1b6$var$rsOptJoin;
var $7b1e4f3aeef3b1b6$var$rsSymbol = "(?:".concat([
    "".concat($7b1e4f3aeef3b1b6$var$rsNonAstral).concat($7b1e4f3aeef3b1b6$var$rsCombo, "?"),
    $7b1e4f3aeef3b1b6$var$rsCombo,
    $7b1e4f3aeef3b1b6$var$rsRegional,
    $7b1e4f3aeef3b1b6$var$rsSurrPair,
    $7b1e4f3aeef3b1b6$var$rsAstral
].join("|"), "\n)");
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7b1e4f3aeef3b1b6$var$reUnicode = RegExp("".concat($7b1e4f3aeef3b1b6$var$rsFitz, "(?=").concat($7b1e4f3aeef3b1b6$var$rsFitz, ")|").concat($7b1e4f3aeef3b1b6$var$rsSymbol).concat($7b1e4f3aeef3b1b6$var$rsSeq), "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $7b1e4f3aeef3b1b6$var$unicodeRange = [
    $7b1e4f3aeef3b1b6$var$rsZWJ,
    $7b1e4f3aeef3b1b6$var$rsAstralRange,
    $7b1e4f3aeef3b1b6$var$rsComboMarksRange,
    $7b1e4f3aeef3b1b6$var$rsComboSymbolsRange,
    $7b1e4f3aeef3b1b6$var$rsVarRange
];
var $7b1e4f3aeef3b1b6$var$reHasUnicode = RegExp("[".concat($7b1e4f3aeef3b1b6$var$unicodeRange.join(""), "]"));
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7b1e4f3aeef3b1b6$var$asciiToArray(string) {
    return string.split("");
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $7b1e4f3aeef3b1b6$var$hasUnicode(string) {
    return $7b1e4f3aeef3b1b6$var$reHasUnicode.test(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7b1e4f3aeef3b1b6$var$unicodeToArray(string) {
    return string.match($7b1e4f3aeef3b1b6$var$reUnicode) || [];
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7b1e4f3aeef3b1b6$var$stringToArray(string) {
    return $7b1e4f3aeef3b1b6$var$hasUnicode(string) ? $7b1e4f3aeef3b1b6$var$unicodeToArray(string) : $7b1e4f3aeef3b1b6$var$asciiToArray(string);
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values.
 *
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7b1e4f3aeef3b1b6$var$toString(value) {
    return value == null ? "" : String(value);
}
/**
 * Splits `string` into an array of characters. If `separator` is omitted,
 * it behaves likes split.split('').
 *
 * Unlike native string.split(''), it can split strings that contain unicode
 * characters like emojis and symbols.
 *
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} [separator=''] The separator pattern to split by.
 * @returns {Array} Returns the string segments.
 * @example
 * toChars('foo');
 * // => ['f', 'o', 'o']
 *
 * toChars('foo bar');
 * // => ["f", "o", "o", " ", "b", "a", "r"]
 *
 * toChars('f😀o');
 * // => ['f', '😀', 'o']
 *
 * toChars('f-😀-o', /-/);
 * // => ['f', '😀', 'o']
 *
 */ function $7b1e4f3aeef3b1b6$var$toChars(string) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    string = $7b1e4f3aeef3b1b6$var$toString(string);
    if (string && $7b1e4f3aeef3b1b6$var$isString(string)) {
        if (!separator && $7b1e4f3aeef3b1b6$var$hasUnicode(string)) return $7b1e4f3aeef3b1b6$var$stringToArray(string);
    }
    return string.split(separator);
}
/**
 * Create an HTML element with the the given attributes
 *
 * attributes can include standard HTML attribute, as well as the following
 * "special" properties:
 *   - children: HTMLElement | ArrayLike<HTMLElement>
 *   - textContent: string
 *   - innerHTML: string
 *
 * @param {string} name
 * @param  {Object} [attributes]
 * @returns {HTMLElement}
 */ function $7b1e4f3aeef3b1b6$var$createElement(name, attributes) {
    var element = document.createElement(name);
    if (!attributes) // When called without the second argument, its just return the result
    // of `document.createElement`
    return element;
    Object.keys(attributes).forEach(function(attribute) {
        var rawValue = attributes[attribute];
        var value = $7b1e4f3aeef3b1b6$var$isString(rawValue) ? rawValue.trim() : rawValue; // Ignore attribute if the value is `null` or an empty string
        if (value === null || value === "") return;
        if (attribute === "children") // Children can be one or more Elements or DOM strings
        element.append.apply(element, $7b1e4f3aeef3b1b6$var$_toConsumableArray($7b1e4f3aeef3b1b6$var$toArray(value)));
        else // Handle standard HTML attributes
        element.setAttribute(attribute, value);
    });
    return element;
}
var $7b1e4f3aeef3b1b6$var$defaults = {
    splitClass: "",
    lineClass: "line",
    wordClass: "word",
    charClass: "char",
    types: [
        "lines",
        "words",
        "chars"
    ],
    absolute: false,
    tagName: "div"
};
/**
 * Splits the text content of a single TextNode into words and/or characters.
 *
 * This functions gets called for every text node inside the target element. It
 * replaces the text node with a document fragment containing the split text.
 * Returns an array of the split word and character elements from this node.
 *
 * @param {TextNode} textNode
 * @param {Object} settings
 * @return {{words: Element[], chars: Element[]}}
 */ function $7b1e4f3aeef3b1b6$var$splitWordsAndChars(textNode, settings) {
    settings = $7b1e4f3aeef3b1b6$var$extend($7b1e4f3aeef3b1b6$var$defaults, settings); // The split types
    var types = $7b1e4f3aeef3b1b6$var$parseTypes(settings.types); // the tag name for split text nodes
    var TAG_NAME = settings.tagName; // value of the text node
    var VALUE = textNode.nodeValue; // `splitText` is a wrapper to hold the HTML structure
    var splitText = document.createDocumentFragment(); // Arrays of split word and character elements
    var words = [];
    var chars = [];
    if (/^\s/.test(VALUE)) splitText.append(" ");
     // Create an array of wrapped word elements.
    words = $7b1e4f3aeef3b1b6$var$toWords(VALUE).reduce(function(result, WORD, idx, arr) {
        // Let `wordElement` be the wrapped element for the current word
        var wordElement;
        var characterElementsForCurrentWord; // -> If splitting text into characters...
        if (types.chars) // Iterate through the characters in the current word
        characterElementsForCurrentWord = $7b1e4f3aeef3b1b6$var$toChars(WORD).map(function(CHAR) {
            var characterElement = $7b1e4f3aeef3b1b6$var$createElement(TAG_NAME, {
                "class": "".concat(settings.splitClass, " ").concat(settings.charClass),
                style: "display: inline-block;",
                children: CHAR
            });
            $7b1e4f3aeef3b1b6$var$set(characterElement, "isChar", true);
            chars = [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(chars), [
                characterElement
            ]);
            return characterElement;
        });
         // END IF;
        if (types.words || types.lines) {
            // -> If Splitting Text Into Words...
            //    Create an element to wrap the current word. If we are also
            //    splitting text into characters, the word element will contain the
            //    wrapped character nodes for this word. If not, it will contain the
            //    plain text content (WORD)
            wordElement = $7b1e4f3aeef3b1b6$var$createElement(TAG_NAME, {
                "class": "".concat(settings.wordClass, " ").concat(settings.splitClass),
                style: "display: inline-block; ".concat(types.words && settings.absolute ? "position: relative;" : ""),
                children: types.chars ? characterElementsForCurrentWord : WORD
            });
            $7b1e4f3aeef3b1b6$var$set(wordElement, {
                isWord: true,
                isWordStart: true,
                isWordEnd: true
            });
            splitText.appendChild(wordElement);
        } else // -> If NOT splitting into words OR lines...
        //    Append the characters elements directly to splitText.
        characterElementsForCurrentWord.forEach(function(characterElement) {
            splitText.appendChild(characterElement);
        });
        if (idx < arr.length - 1) // Add a space after the word.
        splitText.append(" ");
         // If not splitting text into words, we return an empty array
        return types.words ? result.concat(wordElement) : result;
    }, []); // END LOOP;
    // Add a trailing white space to maintain word spacing
    if (/\s$/.test(VALUE)) splitText.append(" ");
    textNode.replaceWith(splitText);
    return {
        words: words,
        chars: chars
    };
}
/**
 * Splits the text content of a target element into words and/or characters.
 * The function is recursive, it will also split the text content of any child
 * elements into words/characters, while preserving the nested elements.
 *
 * @param {Node} node an HTML Element or Text Node
 * @param {Object} setting splitType settings
 */ function $7b1e4f3aeef3b1b6$var$split(node, settings) {
    var type = node.nodeType; // Arrays of split words and characters
    var wordsAndChars = {
        words: [],
        chars: []
    }; // Only proceed if `node` is an `Element`, `Fragment`, or `Text`
    if (!/(1|3|11)/.test(type)) return wordsAndChars;
     // A) IF `node` is TextNode that contains characters other than white space...
    //    Split the text content of the node into words and/or characters
    //    return an object containing the split word and character elements
    if (type === 3 && /\S/.test(node.nodeValue)) return $7b1e4f3aeef3b1b6$var$splitWordsAndChars(node, settings);
     // B) ELSE `node` is an 'Element'
    //    Iterate through its child nodes, calling the `split` function
    //    recursively for each child node.
    var childNodes = $7b1e4f3aeef3b1b6$var$toArray(node.childNodes);
    if (childNodes.length) {
        $7b1e4f3aeef3b1b6$var$set(node, "isSplit", true); // we need to set a few styles on nested html elements
        if (!$7b1e4f3aeef3b1b6$var$get(node).isRoot) {
            node.style.display = "inline-block";
            node.style.position = "relative"; // To maintain original spacing around nested elements when we are
            // splitting text into lines, we need to check if the element should
            // have a space before and after, and store that value for later.
            // Note: this was necessary to maintain the correct spacing when nested
            // elements do not align with word boundaries. For example, a nested
            // element only wraps part of a word.
            var nextSibling = node.nextSibling;
            var prevSibling = node.previousSibling;
            var text = node.textContent || "";
            var textAfter = nextSibling ? nextSibling.textContent : " ";
            var textBefore = prevSibling ? prevSibling.textContent : " ";
            $7b1e4f3aeef3b1b6$var$set(node, {
                isWordEnd: /\s$/.test(text) || /^\s/.test(textAfter),
                isWordStart: /^\s/.test(text) || /\s$/.test(textBefore)
            });
        }
    } // Iterate through child nodes, calling `split` recursively
    // Returns an object containing all split words and chars
    return childNodes.reduce(function(result, child) {
        var _split = $7b1e4f3aeef3b1b6$var$split(child, settings), words = _split.words, chars = _split.chars;
        return {
            words: [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(result.words), $7b1e4f3aeef3b1b6$var$_toConsumableArray(words)),
            chars: [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(result.chars), $7b1e4f3aeef3b1b6$var$_toConsumableArray(chars))
        };
    }, wordsAndChars);
}
/**
 * Gets the height and position of an element relative to offset parent.
 * Should be equivalent to offsetTop and offsetHeight, but with sub-pixel
 * precision.
 *
 * TODO needs work
 */ function $7b1e4f3aeef3b1b6$var$getPosition(node, isWord, settings, scrollPos) {
    if (!settings.absolute) return {
        top: isWord ? node.offsetTop : null
    };
    var parent = node.offsetParent;
    var _scrollPos = $7b1e4f3aeef3b1b6$var$_slicedToArray(scrollPos, 2), scrollX = _scrollPos[0], scrollY = _scrollPos[1];
    var parentX = 0;
    var parentY = 0;
    if (parent && parent !== document.body) {
        var parentRect = parent.getBoundingClientRect();
        parentX = parentRect.x + scrollX;
        parentY = parentRect.y + scrollY;
    }
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height, x = _node$getBoundingClie.x, y = _node$getBoundingClie.y;
    var top = y + scrollY - parentY;
    var left = x + scrollX - parentX;
    return {
        width: width,
        height: height,
        top: top,
        left: left
    };
}
/**
 * Recursively "un-splits" text into words.
 * This is used when splitting text into lines but not words.
 * We initially split the text into words so we can maintain the correct line
 * breaks. Once text has been split into lines, we "un-split" the words...
 * @param {Element}
 * @return {void}
 */ function $7b1e4f3aeef3b1b6$var$unSplitWords(element) {
    if (!$7b1e4f3aeef3b1b6$var$get(element).isWord) $7b1e4f3aeef3b1b6$var$toArray(element.children).forEach(function(child) {
        return $7b1e4f3aeef3b1b6$var$unSplitWords(child);
    });
    else {
        $7b1e4f3aeef3b1b6$var$remove(element);
        element.replaceWith.apply(element, $7b1e4f3aeef3b1b6$var$_toConsumableArray(element.childNodes));
    }
}
var $7b1e4f3aeef3b1b6$var$createFragment = function createFragment() {
    return document.createDocumentFragment();
};
function $7b1e4f3aeef3b1b6$var$repositionAfterSplit(element, settings, scrollPos) {
    var types = $7b1e4f3aeef3b1b6$var$parseTypes(settings.types);
    var TAG_NAME = settings.tagName;
    var nodes = element.getElementsByTagName("*");
    var wordsInEachLine = [];
    var wordsInCurrentLine = [];
    var lineOffsetY = null;
    var elementHeight;
    var elementWidth;
    var contentBox;
    var lines = [];
    /**------------------------------------------------
   ** GET STYLES AND POSITIONS
   **-----------------------------------------------*/ // There is no built-in way to detect natural line breaks in text (when a
    // block of text wraps to fit its container). To split text into lines, we
    // have to detect line breaks by checking the top offset of words. This is
    // why text was split into words first. To apply absolute
    // positioning, its also necessary to record the size and position of every
    // split node (lines, words, characters).
    // To consolidate DOM getting/settings, this is all done at the same time,
    // before actually splitting text into lines, which involves restructuring
    // the DOM again.
    // Cache the element's parent and next sibling (for DOM removal).
    var parent = element.parentElement;
    var nextSibling = element.nextElementSibling; // a wrapper for the new HTML structure
    var splitText = $7b1e4f3aeef3b1b6$var$createFragment(); // get the computed style object for the element
    var cs = window.getComputedStyle(element);
    var align = cs.textAlign;
    var fontSize = parseFloat(cs.fontSize);
    var lineThreshold = fontSize * 0.2; // IF using absolute position...
    if (settings.absolute) {
        // Let contentBox be an object containing the width and offset position of
        // the element's content box (the area inside padding box). This is needed
        // (for absolute positioning) to set the width and position of line
        // elements, which have not been created yet.
        contentBox = {
            left: element.offsetLeft,
            top: element.offsetTop,
            width: element.offsetWidth
        }; // Let elementWidth and elementHeight be the actual width/height of the
        // element. Also check if the element has inline height or width styles
        // already set. If it does, cache those values for later.
        elementWidth = element.offsetWidth;
        elementHeight = element.offsetHeight; // Store the original inline height and width of the element
        $7b1e4f3aeef3b1b6$var$set(element, {
            cssWidth: element.style.width,
            cssHeight: element.style.height
        });
    } // Iterate over every node in the target element
    $7b1e4f3aeef3b1b6$var$toArray(nodes).forEach(function(node) {
        // node is a word element or custom html element
        var isWordLike = node.parentElement === element; // TODO needs work
        // Get te size and position of split text nodes
        var _getPosition = $7b1e4f3aeef3b1b6$var$getPosition(node, isWordLike, settings, scrollPos), width = _getPosition.width, height = _getPosition.height, top = _getPosition.top, left = _getPosition.left; // If element is a `<br>` tag return here
        if (/^br$/i.test(node.nodeName)) return;
        if (types.lines && isWordLike) {
            // We compare the top offset of the current word to the top offset of
            // previous words on the current line. If the difference is greater than
            // our defined threshold (20%), we assume this word is on a new line.
            if (lineOffsetY === null || top - lineOffsetY >= lineThreshold) {
                lineOffsetY = top;
                wordsInEachLine.push(wordsInCurrentLine = []);
            } // Add the current word node to the line array
            wordsInCurrentLine.push(node);
        } // END IF
        if (settings.absolute) // Store the size and position split text nodes
        $7b1e4f3aeef3b1b6$var$set(node, {
            top: top,
            left: left,
            width: width,
            height: height
        });
    }); // END LOOP
    // Remove the element from the DOM
    if (parent) parent.removeChild(element);
    /**------------------------------------------------
   ** SPLIT LINES
   **-----------------------------------------------*/ if (types.lines) {
        // Iterate over lines of text (see 11 b)
        // Let `line` be the array of words in the current line.
        // Return an array of the wrapped line elements (lineElements)
        lines = wordsInEachLine.map(function(wordsInThisLine) {
            // Create an element to wrap the current line.
            var lineElement = $7b1e4f3aeef3b1b6$var$createElement(TAG_NAME, {
                "class": "".concat(settings.splitClass, " ").concat(settings.lineClass),
                style: "display: block; text-align: ".concat(align, "; width: 100%;")
            });
            $7b1e4f3aeef3b1b6$var$set(lineElement, "isLine", true);
            var lineDimensions = {
                height: 0,
                top: 1e4
            }; // Append the `lineElement` to `container`
            splitText.appendChild(lineElement); // Iterate over the word-level elements in the current line.
            // Note: wordOrElement can either be a word node or nested element
            wordsInThisLine.forEach(function(wordOrElement, idx, arr) {
                var _data$get = $7b1e4f3aeef3b1b6$var$get(wordOrElement), isWordEnd = _data$get.isWordEnd, top = _data$get.top, height = _data$get.height;
                var next = arr[idx + 1]; // Determine line height / y-position
                // we use the height and offsetTop of the words which we already
                // recorded. Because custom nested elements could have their own
                // styles, the words on a line may not all be the same height or
                // y position. So we take the greatest height / y - offset of the
                // words on this line.
                lineDimensions.height = Math.max(lineDimensions.height, height);
                lineDimensions.top = Math.min(lineDimensions.top, top); // append the current word/element
                lineElement.appendChild(wordOrElement); // Determine if there should space after the current element...
                // If this is not the last word on the current line.
                // TODO - logic for handing spacing can be improved
                if (isWordEnd && $7b1e4f3aeef3b1b6$var$get(next).isWordStart) lineElement.append(" ");
            }); // END LOOP
            if (settings.absolute) $7b1e4f3aeef3b1b6$var$set(lineElement, {
                height: lineDimensions.height,
                top: lineDimensions.top
            });
            return lineElement;
        }); // END LOOP
        if (!types.words) $7b1e4f3aeef3b1b6$var$unSplitWords(splitText);
         // 10. Insert the new container
        element.replaceChildren(splitText);
    }
    /**------------------------------------------------
   **  SET ABSOLUTE POSITION
   **-----------------------------------------------*/ // Apply absolute positioning to all child elements of the target element.
    // This includes split lines, words, chars, and custom HTML elements that were
    // included by the user. The size and position of child elements has already
    // been recorded before splitting text into lines.
    if (settings.absolute) {
        // Set the width/height of the parent element so it does not collapse
        // when its children are set to absolute position.
        element.style.width = "".concat(element.style.width || elementWidth, "px");
        element.style.height = "".concat(elementHeight, "px"); // Iterate over all child elements
        $7b1e4f3aeef3b1b6$var$toArray(nodes).forEach(function(node) {
            var _data$get2 = $7b1e4f3aeef3b1b6$var$get(node), isLine = _data$get2.isLine, top = _data$get2.top, left = _data$get2.left, width = _data$get2.width, height = _data$get2.height;
            var parentData = $7b1e4f3aeef3b1b6$var$get(node.parentElement);
            var isChildOfLineNode = !isLine && parentData.isLine; // Set the top position of the current node.
            // -> If `node` a line element, we use the top offset of its first child
            // -> If `node` the child of line element, then its top offset is zero
            node.style.top = "".concat(isChildOfLineNode ? top - parentData.top : top, "px"); // Set the left position of the current node.
            // -> IF `node` is a line element, this is equal to the position left of
            //    the content box of the parent element
            // -> IF `node` is the child of a line element, the value has to adjusted
            //    so its relative to the line element
            node.style.left = isLine ? "".concat(contentBox.left, "px") : "".concat(left - (isChildOfLineNode ? contentBox.left : 0), "px"); // Set the height of the current node to the cached value.
            node.style.height = "".concat(height, "px"); //  Set the width of the current node.
            //  If its a line element, width is equal to the width of the contentBox.
            node.style.width = isLine ? "".concat(contentBox.width, "px") : "".concat(width, "px"); // Finally, set the node's position to absolute.
            node.style.position = "absolute";
        });
    } // end if;
    // 14. Re-attach the element to the DOM
    if (parent) {
        if (nextSibling) parent.insertBefore(element, nextSibling);
        else parent.appendChild(element);
    }
    return lines;
}
var $7b1e4f3aeef3b1b6$var$_defaults = $7b1e4f3aeef3b1b6$var$extend($7b1e4f3aeef3b1b6$var$defaults, {});
var $7b1e4f3aeef3b1b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    $7b1e4f3aeef3b1b6$var$_createClass(SplitType, null, [
        {
            key: "clearData",
            /**
     * CLears all data
     */ value: function clearData() {
                $7b1e4f3aeef3b1b6$var$clear();
            }
        },
        {
            key: "setDefaults",
            /**
     * Sets the default settings for all SplitType instances.
     * The provided object will be merged with the existing defaults objects.
     *
     * @param {Object} settings an object containing the settings to override
     * @returns {Object} the new default settings
     * @public
     * @static
     * @example
     * SplitType.setDefaults({ "position": "absolute" })
     */ value: function setDefaults(options) {
                $7b1e4f3aeef3b1b6$var$_defaults = $7b1e4f3aeef3b1b6$var$extend($7b1e4f3aeef3b1b6$var$_defaults, $7b1e4f3aeef3b1b6$var$parseSettings(options));
                return $7b1e4f3aeef3b1b6$var$defaults;
            }
        },
        {
            key: "revert",
            value: function revert(elements) {
                $7b1e4f3aeef3b1b6$var$getTargetElements(elements).forEach(function(element) {
                    var _data$get = $7b1e4f3aeef3b1b6$var$get(element), isSplit = _data$get.isSplit, html = _data$get.html, cssWidth = _data$get.cssWidth, cssHeight = _data$get.cssHeight;
                    if (isSplit) {
                        element.innerHTML = html;
                        element.style.width = cssWidth || "";
                        element.style.height = cssHeight || "";
                        $7b1e4f3aeef3b1b6$var$remove(element);
                    }
                });
            }
        },
        {
            key: "create",
            value: function create(target, options) {
                return new SplitType(target, options);
            }
        },
        {
            key: "data",
            /**
     * The internal data store
     */ get: function get() {
                return $7b1e4f3aeef3b1b6$var$cache;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $7b1e4f3aeef3b1b6$var$_defaults;
            },
            set: function set(options) {
                $7b1e4f3aeef3b1b6$var$_defaults = $7b1e4f3aeef3b1b6$var$extend($7b1e4f3aeef3b1b6$var$_defaults, $7b1e4f3aeef3b1b6$var$parseSettings(options));
            }
        }
    ]);
    function SplitType(elements, options) {
        $7b1e4f3aeef3b1b6$var$_classCallCheck(this, SplitType);
        this.isSplit = false;
        this.settings = $7b1e4f3aeef3b1b6$var$extend($7b1e4f3aeef3b1b6$var$_defaults, $7b1e4f3aeef3b1b6$var$parseSettings(options));
        this.elements = $7b1e4f3aeef3b1b6$var$getTargetElements(elements); // Start the split process
        this.split();
    }
    /**
   * Splits the text in all target elements. This method is called
   * automatically when a new SplitType instance is created. It can also be
   * called manually to re-split text with new options.
   * @param {Object} options
   * @public
   */ $7b1e4f3aeef3b1b6$var$_createClass(SplitType, [
        {
            key: "split",
            value: function split$1(options) {
                var _this = this;
                // Revert target elements (if they are already split)
                // Note: revert was already called once in the constructor. However, we
                // need to call it again here so text is reverted when the user manually
                // calls the `split` method to re-split text.
                this.revert(); // Store the original html content of each target element
                this.elements.forEach(function(element) {
                    $7b1e4f3aeef3b1b6$var$set(element, "html", element.innerHTML);
                }); // Create arrays to hold the split lines, words, and characters
                this.lines = [];
                this.words = [];
                this.chars = []; // cache vertical scroll position before splitting
                var scrollPos = [
                    window.pageXOffset,
                    window.pageYOffset
                ]; // If new options were passed into the `split()` method, update settings
                if (options !== undefined) this.settings = $7b1e4f3aeef3b1b6$var$extend(this.settings, $7b1e4f3aeef3b1b6$var$parseSettings(options));
                var types = $7b1e4f3aeef3b1b6$var$parseTypes(this.settings.types); // If the `types` option is set to an empty array, text will not be split.
                // @example new SplitType('#target', { types: [] })
                if (types.none) return;
                 // Split text in each target element
                this.elements.forEach(function(element) {
                    // Add the split text nodes from this element to the arrays of all split
                    // text nodes for this instance.
                    $7b1e4f3aeef3b1b6$var$set(element, "isRoot", true);
                    var _split2 = $7b1e4f3aeef3b1b6$var$split(element, _this.settings), words = _split2.words, chars = _split2.chars;
                    _this.words = [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(_this.words), $7b1e4f3aeef3b1b6$var$_toConsumableArray(words));
                    _this.chars = [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(_this.chars), $7b1e4f3aeef3b1b6$var$_toConsumableArray(chars));
                });
                this.elements.forEach(function(element) {
                    if (types.lines || _this.settings.absolute) {
                        var lines = $7b1e4f3aeef3b1b6$var$repositionAfterSplit(element, _this.settings, scrollPos);
                        _this.lines = [].concat($7b1e4f3aeef3b1b6$var$_toConsumableArray(_this.lines), $7b1e4f3aeef3b1b6$var$_toConsumableArray(lines));
                    }
                }); // Set isSplit to true for the SplitType instance
                this.isSplit = true; // Set scroll position to cached value.
                window.scrollTo(scrollPos[0], scrollPos[1]); // Clean up stored data
                $7b1e4f3aeef3b1b6$var$cleanup();
            }
        },
        {
            key: "revert",
            value: function revert() {
                if (this.isSplit) {
                    // Reset instance properties if necessary
                    this.lines = null;
                    this.words = null;
                    this.chars = null;
                    this.isSplit = false;
                }
                SplitType.revert(this.elements);
            }
        }
    ]);
    return SplitType;
}();



var $jwdVf = parcelRequire("jwdVf");

var $7Jg0N = parcelRequire("7Jg0N");

var $7oQk4 = parcelRequire("7oQk4");
(0, $9G9Pp.default).registerPlugin((0, $jwdVf.ScrollTrigger));
(0, $9G9Pp.default).config({
    force3D: true
});
document.addEventListener("DOMContentLoaded", ()=>{
    const lenis = new (0, $6dd0effbdfbbcc0f$export$2e2bcd8739ae039)({
        duration: 0.75
    });
    lenis.on("scroll", (0, $jwdVf.ScrollTrigger).update);
    (0, $9G9Pp.default).ticker.add((time)=>{
        lenis.raf(time * 1000);
    });
    const isTouchDevice = (0, $7Jg0N.isTouchPointer)();
    /* Animations */ const fadingTextBlock = document.querySelector("[data-fading-text-block]");
    const introLogo = document.querySelector("[data-main-logo]");
    (0, $7oQk4.introTextBlockFade)(fadingTextBlock, introLogo);
    const introFadingTextLines = document.querySelectorAll("[data-fading-text] .line");
    (0, $7oQk4.fadingTextLines)(introFadingTextLines);
    const logoMarquee = document.querySelector("[data-logos-container]");
    const logos = document.querySelector("[data-logos-container] .logos");
    const logoStrips = logos.querySelectorAll("[data-logos-marquee]");
    (0, $7oQk4.animateLogosIn)(logoMarquee, logos, logoStrips, (0, $7Jg0N.matchMedia));
    const introSection = document.querySelector(".section-intro");
    (0, $7oQk4.animateLogosOut)(introSection, logoMarquee, logos);
    const servicesSection = document.querySelector(".section-services");
    const servicesContainer = document.querySelector(".section-services [data-services-container]");
    const services = document.querySelectorAll(".section-services [data-service]");
    setTimeout(()=>{
        (0, $7oQk4.servicesAnimation)(servicesSection, servicesContainer, services, isTouchDevice, (0, $7Jg0N.matchMedia));
    }, 500);
    const contactSection = document.querySelector(".contact__inner");
    const contactScrollingText = contactSection.querySelector("[data-animate-text]");
    const hiddenContactInfo = contactSection.querySelector("[data-contact-info]");
    const splitText = new (0, $7b1e4f3aeef3b1b6$export$2e2bcd8739ae039)(contactScrollingText, {
        types: "lines, words, chars"
    });
    setTimeout(()=>{
        // The TimeOut is a workaround for a Safari bug
        // inside we use element.getBoundingClientRect() which initially returns wrong values in Safari
        // this seems to be the case for Safari & iOS Safari :(
        (0, $7oQk4.contactAnimation)(contactSection, splitText.chars, hiddenContactInfo);
    }, 500);
});


//# sourceMappingURL=index.4bf8f852.js.map
